<template>
    <div class="root-container">
        <img v-if="paramType != null && paramType != 'channel-talk'" :src="require('@/assets/img_background@3x.png')"
             style="width: 100%"/>
    </div>
</template>

<script>

import {getCurrentInstance, onBeforeMount, ref} from "vue";

export default {
    name: "IntroPage",
    setup() {

        const paramType = ref(null)

        const instance = getCurrentInstance().proxy

        onBeforeMount(() => {

            let params = instance.$common.getUrlParams()
            let type = params.type

            paramType.value = type

            if (type === "channel-talk") {
                bootChannelTalk()
            } else {

                if (paramType.value == null) {
                    paramType.value = "link"
                }

                let link = params.link
                let redirect = params.redirect

                if (link == null || link.length == 0) {

                    if (redirect == null || redirect.length == 0) {
                        window.close()
                    } else {
                        window.location.href = redirect
                    }
                    return
                }

                var packageName = params.package

                if (packageName == null || packageName.length == 0) {
                    packageName = "com.dorbom.dorbom_android"
                }

                let ios_link = link
                let aos_link = getAosLink(link, packageName)

                instance.$apploader.execute({
                    ios: ios_link,
                    aos: aos_link
                }, etcCallback, notFoundCallback)
            }
        })

        const getAosLink = (url, packageName) => {
            let startPosition = url.indexOf("dorbomPlus://") + "dorbomPlus://".length
            let subString = url.substring(startPosition)
            return `intent://${subString}#Intent;scheme=dorbomPlus;package=${packageName};end;`
        }

        const bootChannelTalk = () => {

            window.ChannelIO('boot', {
                "pluginKey": "f50261e1-3abc-476a-acdc-a4ae49e699ef",
                "customLauncherSelector": ".custom-button",
                "hideChannelButtonOnBoot": true,
                "openChatDirectlyAsPossible": true
            }, bootCallback);
        }

        const bootCallback = (error, user) => {
            if (error) {
                user
                window.close()
            } else {
                window.ChannelIO('showMessenger')

                window.ChannelIO('onHide', function () {
                    window.close()
                });
            }
        }

        const etcCallback = () => {

            var osName = 'PC'

            if (/Android/i.test(navigator.userAgent)) {
                osName = 'Android'
            }

            if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                osName = 'iOS'
            }

            if (osName == 'PC') {
                alert('모바일 단말에서 실행해주세요.');
            }

            window.close()
        }

        const notFoundCallback = () => {

            var osName = 'PC'

            if (/Android/i.test(navigator.userAgent)) {
                osName = 'Android'
            }

            if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                osName = 'iOS'
            }

            if (osName == 'iOS') {
                window.location.href = 'https://apps.apple.com/kr/app/%EB%8F%8C%EB%B4%84%ED%94%8C%EB%9F%AC%EC%8A%A4/id1469194764';
            }

            if (osName == 'Android') {
                window.location.href = 'http://play.google.com/store/apps/details?id=com.dorbom.dorbom_android';
            }
        }

        return {
            paramType
        }
    }
}
</script>

<style scoped>
.root-container {
    height: 100%;
    background: #dcf5ef;
}
</style>